/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-concat */
// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { useAccount } from 'wagmi';
import '../App.css';
import FunFactoryAbi from '../config/FunFactoryAbi.json';
import '../styles/MainContainer.css';
import Input from '../components/Input.tsx';
import TextArea from '../components/TextArea.tsx';
import { writeContract, readContract } from '@wagmi/core';
import ClipLoader from 'react-spinners/ClipLoader';
import { waitForTransaction } from '@wagmi/core';
import { toast } from 'react-hot-toast';
import 'react-datepicker/dist/react-datepicker.css';
import TopBar from '../components/TopBar.jsx';
import LogoUploadBox from '../components/LogoUploadBox.jsx';
import BannerUploadBox from '../components/BannerUploadBox.jsx';
import GenerateImageSection from '../components/GenerateImageSection.tsx';
import { web3Clients, chainLogos, feeAmounts, initialEth1, initialEth2, coinNames, supportedChainIds, projectName, apiUrl } from '../utils/constants.ts';
import { getFactoryAddress, getRouterAddress } from '../utils/addressHelpers.ts';
import { Tooltip } from 'react-tooltip';
import { config } from '../config.jsx'

// --- Define Props received from App.jsx ---
// (Assuming AppNotification type is available or defined globally/imported)
interface AppNotification {
    id: string | number;
    type: 'message' | 'invite' | string;
    text: string;
    senderAddress?: string;
    data?: any;
    read: boolean;
    timestamp: number;
}

interface CreateProps {
    notifications: AppNotification[];
    unreadNotificationCount: number;
    onNotificationClick: (notification: AppNotification) => void;
    onClearAllNotifications: () => void;
    onMarkNotificationsRead: (senderAddress: string) => void;
    lastMessage: any;
    isWsConnected: boolean;
    sendWsMessage: (message: any) => void;
}
// --- END Define Props ---

const App: React.FC<CreateProps> = ({
  notifications,
  unreadNotificationCount,
  onNotificationClick,
  onClearAllNotifications,
  // ... other props if needed ...
}) => {
  const [logoPreview, setLogoPreview] = useState<string | null>(null);
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [bannerPreview, setBannerPreview] = useState<string | null>(null);
  const [bannerFile, setBannerFile] = useState<File | null>(null);
  const logoFileInput = useRef<HTMLInputElement>(null);
  const bannerFileInput = useRef<HTMLInputElement>(null);
  const { address, chainId } = useAccount();
  const [maxWallet, setMaxWallet] = useState(1);
  const [chainIdNumber, setChainId] = useState(supportedChainIds.includes(chainId) ? chainId : 97);
  const [routers, setRouters] = useState(getRouterAddress(chainIdNumber));
  const [routerAddr, setRouter] = useState(Object.values(routers)[0]);
  const [tokenName, setTokenName] = useState('');
  const [tokenSymbol, setTokenSymbol] = useState('');
  const [tokenDescription, setTokenDescription] = useState('');
  let [creating, setCreating] = useState(false);
  const [website, setWebsite] = useState('');
  const [telegram, setTelegram] = useState('');
  const [discord] = useState('');
  const [twitter, setTwitter] = useState('');
  const [depositAmount, setDepositAmount] = useState('');

  const [burnFeeAmount, setBurnFeeAmount] = useState(0);
  const [disFeeAmount, setDisFeeAmount] = useState(0);
  const [bondingCurveType, setBondingCurveType] = useState(1);
  const [accountBalance, setAccountBalance] = useState(0);
  const [showMoreOptions, setShowMoreOptions] = useState(false); // State for toggling optional sections

  const [feeAmount, setFeeAmount] = useState(0);


  useEffect(() => {
    const fetchBalance = async () => {
      if (address) {
        let accountBalance = await web3Clients[chainIdNumber].eth.getBalance(address);
        accountBalance = web3Clients[chainIdNumber].utils.fromWei(accountBalance, 'ether');
        setAccountBalance(accountBalance);
        let otherInfos = await readContract(config, {
          address: getFactoryAddress(chainId),
          abi: FunFactoryAbi,
          functionName: 'getOtherInfo',
          chainId: chainId,
        })
        setFeeAmount(otherInfos[0][0])
      }
    };
    if (address) {
      fetchBalance();
    }
  }, [address]);

  const onPumpItUpCreate = async () => {
    try {
      setCreating(true);

      if (!logoFile || !bannerFile) {
        toast.error('Please upload both a logo and a banner');
        setCreating(false);
        return;
      }

      if (Number(depositAmount) > 0) {
        let initialEthAmount;
        if(bondingCurveType === 1){
          initialEthAmount = Number(initialEth1[chainId])
        }else{
          initialEthAmount = Number(initialEth2[chainId])
        }
        let newEthAmount = initialEthAmount + Number(depositAmount)
        let newTokenAmount = 1073 * 10 ** 6 * initialEthAmount / newEthAmount
        let tokenAmount = 1073 * 10 ** 6 - newTokenAmount
        let maxAmount = 1000000000 * maxWallet / 100;


        if (tokenAmount > maxAmount) {
          setCreating(false)
          toast.error(
            "You can't purchase more than " + ' ' + maxAmount.toLocaleString() + ' ' + " tokens"
          )
          return false;
        }
      }
      let disFeeAmounts = disFeeAmount;
      if (bondingCurveType === 2) {
        setDisFeeAmount(0);
        disFeeAmounts = 0;
      }
      let create = await writeContract(config, {
        address: getFactoryAddress(chainId),
        abi: FunFactoryAbi,
        functionName: 'createPumpLaunch',
        value: web3Clients[chainId].utils.toWei(String(Number(feeAmount) / (10 ** 18) + Number(depositAmount)), 'ether'),
        args: [
          [
            tokenName,
            tokenSymbol,
            tokenDescription,
            website,
            twitter,
            telegram,
            discord
          ],
          maxWallet.toString(),
          [
            burnFeeAmount.toString(),
            disFeeAmounts.toString()
          ],
          routerAddr,
          bondingCurveType
        ],
        chainId: chainId
      })
      await waitForTransaction(config, {
        hash: create,
      });

      let otherInfo = await readContract(config, {
        address: getFactoryAddress(chainId),
        abi: FunFactoryAbi,
        functionName: 'getOtherInfo',
        chainId: chainId
      })
      let funAddresses = otherInfo[4];
      let uploadAddress
      let presaleAddress
      if (funAddresses) {
        uploadAddress = projectName + "-" + chainId + "-" + funAddresses[funAddresses.length - 1] + ".png"
        presaleAddress = funAddresses[funAddresses.length - 1]
      }

      // Upload Logo
      const logoFormData = new FormData();

      logoFormData.append('file', logoFile, uploadAddress);
      const logoResponse = await fetch(apiUrl + '/upload-logo', {
        method: 'POST',
        body: logoFormData,
      });
      if (!logoResponse.ok) throw new Error('Failed to upload logo');
      const logoResult = await logoResponse.json();
      console.log('Logo uploaded:', logoResult);

      // Upload Banner
      const bannerFormData = new FormData();

      bannerFormData.append('file', bannerFile, uploadAddress);
      const bannerResponse = await fetch(apiUrl + '/upload-banner', {
        method: 'POST',
        body: bannerFormData,
      });
      if (!bannerResponse.ok) throw new Error('Failed to upload banner');
      const bannerResult = await bannerResponse.json();
      console.log('Banner uploaded:', bannerResult);

      toast.success(
        `Successfully ${tokenName} Meme Launch created`
      )
      const link = `/buy/?chain=${chainId}&address=${presaleAddress}`
      window.location.href = link
    } catch (err) {
      console.error(err);
      toast.error('Failed to create token. Please try again later');
    } finally {
      setCreating(false);
    }
  };

  const [, setImageLogoFile] = useState(null);

  const handleImageLogoChange = (file) => {
    setImageLogoFile(file);
  };

  const [, setImageBannerFile] = useState(null);

  const handleImageBannerChange = (file) => {
    setImageBannerFile(file);
  };

  const LogoImageUpload = ({ onChange, className, style }) => {
    const handleLogoImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = e.target.files![0];
      setLogoFile(selectedFile);
      setLogoPreview(URL.createObjectURL(selectedFile));
      onChange(selectedFile);
    };
    const onButtonClick = () => {
      if (logoFileInput.current) {
        logoFileInput.current.click();
      }
    };
    return (
      <div style={{ width: '100%', position: 'relative' }}>
        <input
          type="file"
          ref={logoFileInput}
          accept="image/*"
          onChange={handleLogoImageChange}
          style={{ display: 'none' }}
        />
        <LogoUploadBox
          handleClick={onButtonClick}
          preview={logoPreview}
          onClear={() => {
            setLogoFile(null);
            setLogoPreview(null);
          }}
          className={'cursor-pointer w-full'}
          style={style}
        />
      </div>
    );
  };

  const BannerImageUpload = ({ onChange, className, style }) => {
    const handleBannerImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = e.target.files![0];
      setBannerFile(selectedFile);
      setBannerPreview(URL.createObjectURL(selectedFile));
      onChange(selectedFile);
    };
    const onButtonClick = () => {
      if (bannerFileInput.current) {
        bannerFileInput.current.click();
      }
    };
    return (
      <div style={{ width: '100%', position: 'relative' }}>
        <input
          type="file"
          ref={bannerFileInput}
          accept="image/*"
          onChange={handleBannerImageChange}
          style={{ display: 'none' }}
        />
        <BannerUploadBox
          handleClick={onButtonClick}
          preview={bannerPreview}
          onClear={() => {
            setBannerFile(null);
            setBannerPreview(null);
          }}
          className={'cursor-pointer w-full'}
          style={style}
        />
      </div>
    );
  };

  const setMaxWalletAmount = (value) => {
    setMaxWallet(value);
  };

  const setBondingCurveTypeValue = (value) => {
    setBondingCurveType(value);
    if (value === 2) {
      setDisFeeAmount(0);
    }
  };

  const changeChain = (value) => {
    setChainId(value);
    const routers = getRouterAddress(value);
    setRouters(routers);
  };

  const setRouterAddress = (value) => {
    setRouter(value);
  };

  return (
    <div className="GlobalContainer">
      <div style={{ zIndex: 1 }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-12 pt-36 pb-24 sm:py-10">
          <section className="lg:mx-auto pt-8 lg:py-[30px] w-full min-w-0 bg-[#6d79ad33] rounded-[10px] lg: px-8 px-2.5 py-5 backdrop-blur-[8px] border-2 border-[#ffffff66]">
            {/* Warning Header */}
            <div className="border-b border-gray-600 pb-4 mb-6 text-center">
              <h1 className="text-[#fff] text-[32px] font-bold">Create Coin</h1>
              <p className="text-[#d3d3d3] text-[14px] mt-1">
                Note: data CANNOT be changed after creation
              </p>
            </div>

            <section>
              <div className="flex flex-col lg:flex-row gap-6">
                {/* Left Column: Logo, Banner, and Generate Image */}
                <div className="lg:w-1/3 flex flex-col gap-6 mt-[54px]">
                  <section className="flex flex-col w-full">
                    <p className="text-[12px] text-[#7db4e5] flex items-center mb-2 order-1">
                      Upload Logo
                      <span className="flex" style={{ color: 'red' }}>*</span>
                      <a className="flex pl-2" id="my-anchor-element">
                        <Tooltip
                          anchorSelect="#my-anchor-element"
                          className="w-64 md:w-80 lg:w-96 max-w-sm"
                          content="Please upload only images in .png, .jpg. The ideal size for uploads is 256x256 pixels for optimal quality and fit."
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="white"
                          strokeWidth={2}
                          className="h-5 w-5 cursor-pointer text-blue-gray-500"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                          />
                        </svg>
                      </a>
                    </p>
                    <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                      <LogoImageUpload
                        onChange={handleImageLogoChange}
                        className={'cursor-pointer'}
                        style={undefined}
                      />
                    </div>
                  </section>

                  <section className="flex flex-col w-full">
                    <p className="text-[12px] text-[#7db4e5] flex items-center mb-2 order-1">
                      Upload Banner
                      <span className="flex" style={{ color: 'red' }}>*</span>
                      <a className="flex pl-2" id="banner-anchor-element">
                        <Tooltip
                          anchorSelect="#banner-anchor-element"
                          className="w-64 md:w-80 lg:w-96 max-w-sm"
                          content="Please upload only images in .png, .jpg. The ideal size for uploads is 1200x600 pixels for optimal quality and fit."
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                          className="h-5 w-5 cursor-pointer text-blue-gray-500"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                          />
                        </svg>
                      </a>
                    </p>
                    <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                      <BannerImageUpload
                        onChange={handleImageBannerChange}
                        className={'cursor-pointer'}
                        style={undefined}
                      />
                    </div>
                  </section>

                  <GenerateImageSection
                    tokenName={tokenName}
                    tokenSymbol={tokenSymbol}
                    tokenDescription={tokenDescription}
                    setLogoFile={setLogoFile}
                    setLogoPreview={setLogoPreview}
                    setBannerFile={setBannerFile}
                    setBannerPreview={setBannerPreview}
                  />
                </div>

                {/* Right Column: General Information and Features */}
                <div className="lg:w-2/3 flex flex-col gap-6">
                  {/* General Information */}
                  <h1 className="text-[#fff] w-full text-[20px] font-bold">General Information</h1>

                  <section className="flex flex-col w-full">
                    <p className="text-[12px] text-[#7db4e5] mb-2 order-1">
                      Token Name<span style={{ color: 'red' }}>*</span>
                    </p>
                    <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                      <Input
                        placeholder="Enter the token name"
                        label=""
                        type="text"
                        changeValue={setTokenName}
                        value={tokenName}
                      />
                    </div>
                  </section>

                  <section className="flex flex-col w-full">
                    <p className="text-[12px] text-[#7db4e5] mb-2 order-1">
                      Simbol<span style={{ color: 'red' }}>*</span>
                    </p>
                    <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                      <Input
                        placeholder="Enter the Simbol"
                        label=""
                        type="text"
                        changeValue={setTokenSymbol}
                        value={tokenSymbol}
                      />
                    </div>
                  </section>

                  <section className="flex flex-col w-full">
                    <p className="text-[12px] text-[#7db4e5] mb-2 order-1">
                      Token Description (Max 1000 characters)<span style={{ color: 'red' }}>*</span>
                    </p>
                    <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                      <TextArea
                        rows={4}
                        placeholder="Enter the description"
                        changeValue={setTokenDescription}
                        value={tokenDescription}
                      />
                    </div>
                  </section>

                  {/* Features */}
                  <h1 className="text-[#fff] w-full text-[20px] font-bold">Features</h1>

                  <section className="flex flex-col w-full">
                    <p className="text-[12px] text-[#7db4e5] mb-2 order-1">
                      Max Wallet (%)<span style={{ color: 'red' }}>*</span>
                    </p>
                    <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                      <section className="inputPanel">
                        <section className="inputPanelHeader">
                          <div className="fairlaunch-allocation-buttons-container">
                            <button
                              className="fairlaunch-allocation-button"
                              onClick={() => setMaxWalletAmount(1)}
                              style={
                                maxWallet === 1
                                  ? {}
                                  : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                              }
                            >
                              1%
                            </button>
                            <button
                              className="fairlaunch-allocation-button"
                              onClick={() => setMaxWalletAmount(2)}
                              style={
                                maxWallet === 2
                                  ? {}
                                  : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                              }
                            >
                              2%
                            </button>
                          </div>
                        </section>
                      </section>
                    </div>
                  </section>

                  <section className="flex flex-col w-full">
                    <p className="text-[12px] text-[#7db4e5] flex items-center mb-2 order-1">
                      Bundle Amount ({coinNames[chainIdNumber]})
                      <a className="flex pl-2" id="snipe-anchor-element">
                        <Tooltip
                          anchorSelect="#snipe-anchor-element"
                          className="w-64 md:w-80 lg:w-96 max-w-sm"
                          content="This is where you input how much you want to buy at launch. Bundling means automatically buying tokens with your dev wallet in the same txhash as the token deployment. This feature guarantees you will be the first buyer of your own token."
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="white"
                          strokeWidth={2}
                          className="h-5 w-5 cursor-pointer text-blue-gray-500"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                          />
                        </svg>
                      </a>
                    </p>
                    <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                      <section className="inputPanel">
                        <section className="inputPanelHeader w-full">
                          <Input
                            placeholder="Enter Snipe Amount"
                            label=""
                            type="number"
                            changeValue={setDepositAmount}
                            value={depositAmount}
                          />
                        </section>
                      </section>
                    </div>
                  </section>
                  <section className="flex flex-row w-full mr-1">
                    <section className="flex flex-col w-[50%]">
                      <p className="text-[12px] text-[#7db4e5] flex items-center mb-2 order-1">
                        Deflationary Fee
                        <a className="flex pl-2" id="snipe-anchor-element1">
                          <Tooltip
                            anchorSelect="#snipe-anchor-element1"
                            className="w-64 md:w-80 lg:w-96 max-w-sm"
                            content="Set a deflationary fee percentage (1-3%) to burn a portion of each transaction, reducing the circulating supply of the token over time."
                          />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="white"
                            strokeWidth={2}
                            className="h-5 w-5 cursor-pointer text-blue-gray-500"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                            />
                          </svg>
                        </a>
                      </p>
                      <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                        <section className="inputPanel">
                          <section className="inputPanelHeader">
                            <div className="fairlaunch-allocation-buttons-container">
                              <button
                                className="fairlaunch-allocation-button"
                                onClick={() => setBurnFeeAmount(0)}
                                style={
                                  burnFeeAmount === 0
                                    ? {}
                                    : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                                }
                              >
                                0%
                              </button>
                              <button
                                className="fairlaunch-allocation-button"
                                onClick={() => setBurnFeeAmount(1)}
                                style={
                                  burnFeeAmount === 1
                                    ? {}
                                    : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                                }
                              >
                                1%
                              </button>
                              <button
                                className="fairlaunch-allocation-button"
                                onClick={() => setBurnFeeAmount(2)}
                                style={
                                  burnFeeAmount === 2
                                    ? {}
                                    : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                                }
                              >
                                2%
                              </button>
                              <button
                                className="fairlaunch-allocation-button"
                                onClick={() => setBurnFeeAmount(3)}
                                style={
                                  burnFeeAmount === 3
                                    ? {}
                                    : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                                }
                              >
                                3%
                              </button>
                            </div>
                          </section>
                        </section>
                      </div>
                    </section>
                    {bondingCurveType === 1 &&
                      <section className="flex flex-col w-[50%] ml-1">
                        <p className="text-[12px] text-[#7db4e5] flex items-center mb-2 order-1">
                          Distribution Fee
                          <a className="flex pl-2" id="snipe-anchor-element2">
                            <Tooltip
                              anchorSelect="#snipe-anchor-element2"
                              className="w-64 md:w-80 lg:w-96 max-w-sm"
                              content="Define the percentage (1-3%) of each transaction to be distributed to token holders, rewarding them for holding the token."
                            />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="white"
                              strokeWidth={2}
                              className="h-5 w-5 cursor-pointer text-blue-gray-500"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                              />
                            </svg>
                          </a>
                        </p>
                        <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                          <section className="inputPanel">
                            <section className="inputPanelHeader">
                              <div className="fairlaunch-allocation-buttons-container">
                                <button
                                  className="fairlaunch-allocation-button"
                                  onClick={() => setDisFeeAmount(0)}
                                  style={
                                    disFeeAmount === 0
                                      ? {}
                                      : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                                  }
                                >
                                  0%
                                </button>
                                <button
                                  className="fairlaunch-allocation-button"
                                  onClick={() => setDisFeeAmount(1)}
                                  style={
                                    disFeeAmount === 1
                                      ? {}
                                      : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                                  }
                                >
                                  1%
                                </button>
                                <button
                                  className="fairlaunch-allocation-button"
                                  onClick={() => setDisFeeAmount(2)}
                                  style={
                                    disFeeAmount === 2
                                      ? {}
                                      : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                                  }
                                >
                                  2%
                                </button>
                                <button
                                  className="fairlaunch-allocation-button"
                                  onClick={() => setDisFeeAmount(3)}
                                  style={
                                    disFeeAmount === 3
                                      ? {}
                                      : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                                  }
                                >
                                  3%
                                </button>
                              </div>
                            </section>
                          </section>
                        </div>
                      </section>}

                  </section>

                  <section className="flex flex-col w-full">
                    <p className="text-[12px] text-[#7db4e5] mb-2 order-1 flex">
                      Bonding Curve Type <span style={{ color: 'red' }}>*</span>
                      <a className="flex pl-2" id="snipe-anchor-element3">
                        <Tooltip
                          anchorSelect="#snipe-anchor-element3"
                          className="w-64 md:w-80 lg:w-96 max-w-sm"
                          content={bondingCurveType === 1 ? "Once the token reaches a market cap of $69,000, it will automatically be listed on a decentralized exchange (DEX)." : "Upon reaching $50,000 in total value, the token will be eligible for listing on one of the following exchanges: XT, LBANK, or BITMART, selected by the project's community."}
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="white"
                          strokeWidth={2}
                          className="h-5 w-5 cursor-pointer text-blue-gray-500"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                          />
                        </svg>
                      </a>
                    </p>
                    <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                      <section className="inputPanel">
                        <section className="inputPanelHeader">
                          <div className="fairlaunch-allocation-buttons-container">
                            <button
                              className="fairlaunch-allocation-button"
                              onClick={() => setBondingCurveTypeValue(1)}
                              style={
                                bondingCurveType === 1
                                  ? {}
                                  : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                              }
                            >
                              1
                            </button>
                            <button
                              className="fairlaunch-allocation-button"
                              onClick={() => setBondingCurveTypeValue(2)}
                              style={
                                bondingCurveType === 2
                                  ? {}
                                  : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                              }
                            >
                              2
                            </button>
                          </div>
                        </section>
                      </section>
                    </div>
                  </section>
                  {/* Show More Options Toggle */}
                  <div
                    className="flex items-center gap-2 cursor-pointer"
                    onClick={() => setShowMoreOptions(!showMoreOptions)}
                  >
                    <p className="text-[#7db4e5] text-[14px]">
                      {showMoreOptions ? 'Hide more options' : 'Show more options'}
                    </p>
                    <svg
                      className={`w-4 h-4 text-[#7db4e5] transform ${showMoreOptions ? 'rotate-180' : ''}`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>

                  {/* Optional Sections: Social and DEX */}
                  {showMoreOptions && (
                    <>
                      {/* Social Links */}
                      <h1 className="text-[#fff] w-full text-[20px] font-bold">Social Links</h1>

                      <section className="flex flex-col w-full">
                        <p className="text-[12px] text-[#7db4e5] mb-2 order-1">Telegram Link</p>
                        <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                          <Input
                            placeholder="Enter the telegram URL"
                            label=""
                            type="text"
                            changeValue={setTelegram}
                            value={telegram}
                          />
                        </div>
                      </section>
                      <section className="flex flex-col w-full">
                        <p className="text-[12px] text-[#7db4e5] mb-2 order-1">X Link</p>
                        <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                          <Input
                            placeholder="Enter the X URL"
                            label=""
                            type="text"
                            changeValue={setTwitter}
                            value={twitter}
                          />
                        </div>
                      </section>

                      <section className="flex flex-col w-full">
                        <p className="text-[12px] text-[#7db4e5] mb-2 order-1">Website</p>
                        <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                          <Input
                            placeholder="Enter the website URL"
                            label=""
                            type="text"
                            changeValue={setWebsite}
                            value={website}
                          />
                        </div>
                      </section>

                      {/* DEX */}
                      {bondingCurveType === 1 &&
                        <>
                          <h1 className="text-[#fff] w-full text-[20px] font-bold">DEX</h1>

                          <section className="flex flex-col w-full">
                            <p className="text-[12px] text-[#7db4e5] mb-2 order-1">Network</p>
                            <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                              <div className="fairlaunch-allocation-buttons-container">
                                {supportedChainIds.map((id) => (
                                  <button
                                    key={id}
                                    className={`${chainIdNumber === id ? 'opacity-100' : 'opacity-30'}`}
                                    onClick={() => changeChain(id)}
                                  >
                                    <img src={chainLogos[id]} className="w-8" />
                                  </button>
                                ))}
                              </div>
                            </div>
                          </section>

                          <section className="flex flex-col w-full">
                            <p className="text-[12px] text-[#7db4e5] mb-2 order-1">Dex</p>
                            <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px] w-full">
                              <div className="fairlaunch-allocation-buttons-container">
                                {Object.entries(routers).map(([key, value]) => (
                                  <button
                                    className="fairlaunch-allocation-button"
                                    onClick={() => setRouterAddress(value)}
                                    style={
                                      routerAddr === value
                                        ? {}
                                        : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                                    }
                                  >
                                    {key}
                                  </button>
                                ))}
                              </div>
                            </div>
                          </section>
                        </>
                      }
                    </>
                  )}
                </div>
              </div>

              {/* Create Coin Button */}
              <div className="mt-8 flex justify-center">
                <button
                  disabled={
                    tokenName === '' ||
                    tokenSymbol === '' ||
                    tokenDescription === '' ||
                    creating ||
                    !logoFile ||
                    !bannerFile ||
                    feeAmounts[chainId] + Number(depositAmount) > accountBalance
                  }
                  onClick={onPumpItUpCreate}
                  className="px-6 py-3 bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-white rounded-lg disabled:opacity-50"
                >
                  {creating ? <ClipLoader
                    color={'#fff'}
                    loading={creating}
                    size={30}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  /> : 'Create Coin'}
                </button>
              </div>
            </section>
          </section>
        </div>
      </div>
    </div>
  );
};

export default App;